// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Button } from '@mui/material';

// project imports
import { Logo } from '../index';
import HeaderSections from './sections/HeaderSections';
import { useSelector } from 'react-redux';
import { selectIsMobile } from 'store/slice/SliceSidebar';
import { useNavigate } from 'react-router-dom';

// types
import PropTypes from 'prop-types';

// assets
import { IconMenu2 } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle, children }) => {
    const theme = useTheme();
    const isMobile = useSelector(selectIsMobile);
    const navigate = useNavigate();
    
    // Redux store에서 인증 상태 확인
    const { loginState } = useSelector((state) => state.auth);

    const handleLoginClick = () => {
        navigate('/login');
    };

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden', marginRight: '1rem' }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
                <Box component="span" sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    width: isMobile ? '120px' : 'auto'
                }}>
                    <Logo isMobile={isMobile} />
                </Box>
                
            </Box>

            {/* header search */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />

            {/* notification & profile 또는 로그인 버튼 */}
            {loginState ? (
                <HeaderSections />
            ) : (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleLoginClick}
                    sx={{
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1
                    }}
                >
                    로그인
                </Button>
            )}
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
